import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

// Enterprise Status Page Routes
const URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE = `${URL_APP_ADMIN}/enterprise-status-page`

// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'app-admin-enterprise-status-page'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-enterprise-status-page': URL_APP_ADMIN_ENTERPRISE_STATUS_PAGE,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
